import {
  needSupport2,
  needSupport3,
  needSupport4,
  needSupport5,
} from '@apphero/assets'

export const supportSections = [
  {
    id: 1,
    text: "Watch our helpful video tutorial to guide you through the application process. Learn how to check your application status, complete any outstanding tasks, locate your offer letter, and find the documents you've uploaded. We've also included contact information for your advisor in case you have any questions. We're here to support you every step of the way!.",
    image: needSupport2,
    videoId: 'xdKcR54Ok6A?si=llrgQPAZDQxlGXvb',
  },
  {
    id: 2,
    text: "Watch our helpful video tutorial to guide you through the application process. Learn how to check your application status, complete any outstanding tasks, locate your offer letter, and find the documents you've uploaded. We've also included contact information for your advisor in case you have any questions. We're here to support you every step of the way!.",
    image: needSupport3,
    videoId: 'A25J-1efDUE?si=JOgpIxpE03--haYd',
  },
  {
    id: 3,
    text: "Watch our helpful video tutorial to guide you through the application process. Learn how to check your application status, complete any outstanding tasks, locate your offer letter, and find the documents you've uploaded. We've also included contact information for your advisor in case you have any questions. We're here to support you every step of the way!.",
    image: needSupport4,
    videoId: 's7303eKmQD0?si=dcAlwrdDiY9zIHCL',
  },
  {
    id: 4,
    text: "Watch our helpful video tutorial to guide you through the application process. Learn how to check your application status, complete any outstanding tasks, locate your offer letter, and find the documents you've uploaded. We've also included contact information for your advisor in case you have any questions. We're here to support you every step of the way!.",
    image: needSupport5,
    videoId: 'K0_i5bTac30?si=KnlksklgXbD4srbf',
  },
]
